import { render, staticRenderFns } from "./FieldsetWrap.vue?vue&type=template&id=4bcc6982&scoped=true&"
import script from "./FieldsetWrap.vue?vue&type=script&lang=ts&"
export * from "./FieldsetWrap.vue?vue&type=script&lang=ts&"
import style0 from "./FieldsetWrap.vue?vue&type=style&index=0&id=4bcc6982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc6982",
  null
  
)

export default component.exports